import React from 'react';
import PropTypes from 'prop-types';

const IconChevronUp = ({ size, fill }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill={fill}
        viewBox="0 200 1792 1792"
    >
        <path d="M1683 1331l-166 165q-19 19-45 19t-45-19l-531-531-531 531q-19 19-45 19t-45-19l-166-165q-19-19-19-45.5t19-45.5l742-741q19-19 45-19t45 19l742 741q19 19 19 45.5t-19 45.5z" />
    </svg>
);

IconChevronUp.propTypes = {
    size: PropTypes.number.isRequired,
    fill: PropTypes.string.isRequired,
};

IconChevronUp.defaultProps = {
    size: 15,
    fill: 'white',
};

IconChevronUp.displayName = 'IconChevronUp';

export default IconChevronUp;
